import Vue from 'vue';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import mavonEditor from 'mavon-editor';

import 'mavon-editor/dist/css/index.css';
import '@/assets/scss/variables.scss';
import '@/assets/scss/init.scss';

Vue.use(mavonEditor);

import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
